export const moneyTile = {
    id: 'money',
    name: 'Money',
    info: 'To access the Manzil Halal Portfolios, click on START INVESTING below.',
    bgColour: '#81B29A',
    colour: '#FCFAF2',
    cta: 'Start investing',
    url: 'https://form.typeform.com/to/qxM1vl0l',
    buttonId: 'Backend-Start-Investing'
};

export const productsAndServices = [
    {
        id: 'wills',
        name: 'Wills',
        info: 'The Fastest and most convenient way to create your Islamic Will in Canada.',
        bgColour: '#5F797B',
        colour: '#FCFAF2',
        cta: 'Create my will',
        url: '',
        buttonId: 'Backend-Wills-Create-My-Will'
    },
    {
        id: 'homes',
        name: 'Homes',
        info: 'Apply to purchase your new home or transfer your existing mortgage.',
        bgColour: '#3D405B',
        colour: '#FCFAF2',
        cta: 'Join the waitlist',
        url: 'https://form.typeform.com/to/ty79jANs',
        buttonId: 'Backend-Homes-Join-Waitlist'
    },
    {
        id: 'realty',
        name: 'Realty',
        info: 'Buying, selling, renting or looking for a tenant.',
        bgColour: '#6B5A67',
        colour: '#FCFAF2',
        cta: 'Get started',
        url: '',
        buttonId: 'Backend-Realty-Get-Started'
    },
    {
        id: 'cards',
        name: 'Cards',
        info: 'Get your Halal prepaid Visa card today.',
        bgColour: '#F2CC8F',
        colour: '#3D405B',
        cta: 'Get started',
        url: 'https://form.typeform.com/to/obmdXKb7',
        buttonId: 'Backend-Cards-Get-Started'
    },
    // {
    //     id: 'wheel',
    //     name: 'Wheels',
    //     info: 'The only Halal car financing in Canada using a trade based transaction.',
    //     bgColour: '#8F5D5D',
    //     colour: '#FCFAF2',
    //     cta: 'Join the waitlist',
    //     url: 'https://form.typeform.com/to/ty79jANs',
    //     buttonId: 'Backend-Wheels-Join-Waitlist'
    // },

];
